module.exports = __webpack_public_path__ + "img/img-7.76e55f27.jpg";